<template>
  <article>
    <b-columns>
      <b-column class="is-narrow">
        <header>
          <h3 class="category-heading is-size-4">{{ data.name }}</h3>
        </header>
      </b-column>
      <b-column v-if="data.guide_pdf">
        <pdf-link :url="data.guide_pdf" />
      </b-column>
    </b-columns>

    <paragraph-with-header heading="Guide">
      {{ data.guide | nullToDash }}
    </paragraph-with-header>
  </article>
</template>

<script>
import ParagraphWithHeader from '@/components/structures/ParagraphWithHeader'

export default {
  name: 'SamplingType',
  components: {
    ParagraphWithHeader
  },
  props: {
    data: {
      type: Object,
      default: () => ({ name: '' })
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style>

</style>
